import { mutationTypes } from './types';

const mutations = {
  [mutationTypes.SET_CATEGORIES](state, payload) {
    state.categories = payload;
  },
  [mutationTypes.SET_FILTER](state, payload) {
    state.filter = {
      categoryCode: payload.categoryCode,
      searchField: payload.searchField,
      isAtive: payload.isAtive,
    };
  },
  [mutationTypes.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [mutationTypes.SET_RESULTS](state, payload) {
    state.results = payload.data;
    state.pagination.totalItemCount = payload.totalItemCount;
    state.pagination.currentPage = payload.currentPage;
    state.pagination.pageCount = payload.pageCount;
  },
};

export default mutations;
